import Vue from 'vue'
import Router from 'vue-router'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
import Layout from '@/views/layout/Layout'

/**
* hidden: true                   如果“hidden:true”不会在侧边栏显示(默认为false)
* alwaysShow: true               如果设置为true，将始终显示根菜单，无论它的子路径长度是多少
*                                如果不设置总路线，只在子路由下面多走一条路线
*                                它将变成嵌套模式，不会显示根菜单
* redirect: noredirect           设置为“noredirect”不会在面包屑中重定向
* name:'router-name'             <保持激活状态>要用到此名称 (必须设置)
* meta : {
    roles: ['admin','editor']    设置页面的访问角色(可以设置多个角色)
    title: 'title'               显示在子菜单和面包屑中的标题
    icon: 'svg-name'             侧边栏中显示的图标,
    noCache: true                true如果为真，页面将不会被缓存(默认为false)
  }
**/
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/erpLogin', component: () => import('@/views/login/erpLogin'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },

  {
    path: '/',
    component: Layout,
    //redirect: '/dashboard',
    hidden: true,
    //redirect: noredirect,
    //hidden: false,
    children: [{
      path: 'dashboard',
      name:"主页",
      component: () => import('@/views/dashboard/index'),
      meta: { title: '主页', icon: 'dashboard',noCache: false},
    }]
  },

  {
    path: '/analyze',
    component: Layout,
    target:"",
    children: [
      {
        path: 'analyzeQuote',
        name: 'Name_analyzeQuote',
        component: () => import('@/views/reqQuote/analyzeQuote.vue'),
        meta: { title: 'systemAnalysis', icon: 'form', }
      }
    ]
  },

  {
    path: '/customer',
    component: Layout,
    hidden: true,
    target:"",
    children: [
      {
        path: 'search',
        name: 'customer',

        component: () => import('@/views/reqQuote/Customer.vue'),
        meta: { title: 'customerInformation', icon: 'form' }
      }
    ],
   
  },

  {
    path: '/quoteQuery',
    redirect:'/quoteQuery/Query',
    target:"",
    component: Layout,
    children: [
      {
        path: 'Query',
        name: 'Query',
        component: () => import('@/views/reqQuote/QuoteSearch.vue'),
        meta: { title: 'quotationInquiry', icon: 'form', keepAlive:true,limitName:'quoteApplay'  }
      }
    ]
  },


  {
    path: '/addQuote',
    component: Layout,
    target:"",
    children: [
      {
        path: 'addReqQuoteMgmt',
        name: 'Name_addReqQuoteMgmt',
        component: () => import('@/views/reqQuote/reqQuoteMgmt.vue'),
        meta: { title: 'createANew', icon: 'form',keepAlive:true,limitName:'quoteApplay'  }
      }
    ]
  },

  {
    path: '/editQuote',
    component: Layout,
    hidden: true,
    target:"",
    children: [
      {
        path: 'editReqQuoteMgmt',
        name: 'Name_editReqQuoteMgmt',
        component: () => import('@/views/reqQuote/reqQuoteMgmt.vue'),
        meta: { title: 'modifyTheQuote', icon: 'form',limitName:'quoteApplay'  }
      }
    ]
  },
  {
    path: '/historyQuote',
    component: Layout,
    hidden: true,
    target:"",
    children: [
      {
        path: 'historyQuoteMgmt',
        name: 'Name_historyQuoteMgmt',
        component: () => import('@/views/reqQuote/reqQuoteMgmt.vue'),
        meta: { title: 'historicalData', icon: 'form',limitName:'quoteApplay'  }
      }
    ]
  },


  /* Start 坑纸 */

  {
    path: '/addQuoteCTN',
    component: Layout,
    target:"",
    children: [
      {
        path: 'addReqQuoteMgmtCTN',
        name: 'Name_addReqQuoteMgmtCTN',
        component: () => import('@/views/reqQuote/reqQuoteMgmt.CTN.vue'),
        meta: { title: 'createANewPittedPaper', icon: 'form',keepAlive:true,limitName:'quoteApplay'  }
      }
    ]
  },

  {
    path: '/editQuoteCTN',
    component: Layout,
    hidden: true,
    target:"",
    children: [
      {
        path: 'editReqQuoteMgmtCTN',
        name: 'Name_editReqQuoteMgmtCTN',
        component: () => import('@/views/reqQuote/reqQuoteMgmt.CTN.vue'),
        meta: { title: 'modifyTheQuote', icon: 'form',limitName:'quoteApplay'  }
      }
    ]
  },
  {
    path: '/historyQuoteCTN',
    component: Layout,
    hidden: true,
    target:"",
    children: [
      {
        path: 'historyQuoteMgmtCTN',
        name: 'Name_historyQuoteMgmtCTN',
        component: () => import('@/views/reqQuote/reqQuoteMgmt.CTN.vue'),
        meta: { title: 'historicalData', icon: 'form',limitName:'quoteApplay'  }
      }
    ]
  },

  /* End 坑纸 */
  

  /* Start 快速开版 */

  // {
  //   path: '/addQuoteFast',
  //   component: Layout,
  //   target:"",
  //   children: [
  //     {
  //       path: 'addReqQuoteMgmtFast',
  //       name: 'Name_addReqQuoteMgmtFast',
  //       component: () => import('@/views/reqQuote/reqQuoteMgmt_Fast.vue'),
  //       meta: { title: '新建报价申请(快速)', icon: 'form',keepAlive:true,limitName:'quoteApplay'  }
  //     }
  //   ]
  // },

  // {
  //   path: '/editQuoteFast',
  //   component: Layout,
  //   hidden: true,
  //   target:"",
  //   children: [
  //     {
  //       path: 'editReqQuoteMgmtFast',
  //       name: 'Name_editReqQuoteMgmtFast',
  //       component: () => import('@/views/reqQuote/reqQuoteMgmt_Fast.vue'),
  //       meta: { title: '修改报价申请', icon: 'form',limitName:'quoteApplay'  }
  //     }
  //   ]
  // },

  /* End 快速开版 */

  {
    path: '/reqQuote',
    component: Layout,
    //target:"_blank",
    hidden: true,
    children: [
      {
        path: 'erpQuote',
        name: 'Name_erpQuote',
        component: () => import('@/views/reqQuote/erpQuote.vue'),
        meta: { title: 'quotation', icon: 'form' }
      }
    ],
  },

  
  {
    path: '/product',
    component: Layout,
    target:"_blank",
    children: [
      {
        path: 'ProductDefine',
        name: 'product',
        component: () => import('@/views/example/ProductDefine.vue'),
        meta: { title: 'productSettings', icon: 'form' ,limitName:'productDefined' }
      }
    ],
  },
  
  {
    path: '/procedure',
    component: Layout,
    hidden: true,
    target:"_blank",
   // redirect: noredirect,
    children: [
      {
        path: 'parameterSetting',
        name: 'procedure-parameterSetting',
        component: () => import('@/views/procedure/parameterSetting.vue'),
        meta: { title: 'quotedProcessParameters', icon: 'form',limitName:'procedureParam'  }
      }
    ]
  },

  
  {
    path: '/pullWireSetting',
    component: Layout,
    // target:"_blank",
    children: [
      {
        path: 'index',
        name: 'pullWireSetting',
        component: () => import('@/views/pullWireSetting/index.vue'),
        meta: { title: 'cableSetting', icon: 'form' ,limitName:'pullWireSetting' }
      }
    ],
  },
  
 
  
  {
    path: '/example',
    component: Layout,
    redirect: '/example/table',
    hidden: true,
    name: 'Example',
    meta: { title: '开发示例', icon: 'example' },
    children: [
      {
        path: 'table',
        name: 'Table',
        component: () => import('@/views/table/index'),
        meta: { title: 'Data读取', icon: 'table' }
      },
      {
        path: 'tree',
        name: 'Tree',
        component: () => import('@/views/tree/index'),
        meta: { title: '树形菜单', icon: 'tree' }
      },
      {
        path: 'example1',
        name: 'example1',
        component: () => import('@/views/example/example1.vue'),
        meta: { title: '动态加载组件', icon: 'tree' }
      },
      {
        path: 'example2',
        name: 'example2',
        component: () => import('@/views/example/complexDt.vue'),
        meta: { title: '表格增删改查', icon: 'tree' }
      },
      {
        path: 'index',
        name: 'Form',
        component: () => import('@/views/form/index'),
        meta: { title: '表单操作', icon: 'form' }
      },
      {
        path: 'UploadFile',
        name: 'UploadFile',
        component: () => import('@/views/example/UploadFile.vue'),
        meta: { title: '上传文件', icon: 'tree' }
      }
      ,
      {
        path: 'materialChoice',
        name: 'materialChoice',
        component: () => import('@/components/materialChoice.vue'),
        meta: { title: '物料选择', icon: 'tree' }
      }
      ,
      {
        path: 'printColor',
        name: 'printColor',
        component: () => import('@/components/printColor.vue'),
        meta: { title: '印色选择', icon: 'tree' }
      },
      {
        path: 'AddProduct',
        name: 'AddProduct',
        component: () => import('@/components/AddProduct.vue'),
        meta: { title: '产品添加', icon: 'tree' }
      },
      
      
    ]
  },
  
  { path: '*', redirect: '/404', hidden: true },
 
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js